import { useMemo } from 'react';
import { getObjectTypeNamePlural, getObjectTypeNameSingular } from 'marketing-platform-lib/utils/objectName';
import useFetchCrmObjectTypeDefinitions from './useFetchCrmObjectTypeDefinitions';
export default function useCrmObjectName(objectTypeId, {
  textTransform,
  typeDefinition,
  skip
} = {
  textTransform: 'lowercase'
}) {
  const {
    data: typeDefinitionsFromFetch
  } = useFetchCrmObjectTypeDefinitions({
    skip: !!typeDefinition || skip
  });
  const typeDefinitionFromFetch = typeDefinitionsFromFetch ? typeDefinitionsFromFetch.find(td => td.objectTypeId === objectTypeId) : undefined;
  const typeDefinitionResolved = typeDefinition || typeDefinitionFromFetch;
  const objectTypeNamePlural = useMemo(() => getObjectTypeNamePlural({
    objectTypeId,
    textTransform,
    typeDefinition: typeDefinitionResolved
  }), [objectTypeId, textTransform, typeDefinitionResolved]);
  const objectTypeNameSingular = useMemo(() => getObjectTypeNameSingular({
    objectTypeId,
    textTransform,
    typeDefinition: typeDefinitionResolved
  }), [objectTypeId, textTransform, typeDefinitionResolved]);
  return {
    objectTypeNamePlural,
    objectTypeNameSingular
  };
}